import React, { useState, useRef, useEffect, useContext } from 'react';
import {
	Popper,
	Grow,
	ClickAwayListener,
	Paper,
	MenuList,
	MenuItem,
	ListItemIcon,
	ListItemText,
	TableCell,
	TableRow,
	Checkbox,
	Button,
	IconButton,
	Modal,
} from '@material-ui/core';
import { Context as InvoicesContext } from '../context/invoices.context';
import PrintIcon from '@material-ui/icons/Print';
import DownloadIcon from '@material-ui/icons/GetApp';
import EyeIcon from '@material-ui/icons/Visibility';
import CancelIcon from '@material-ui/icons/Cancel';
import { useMediaQuery } from 'react-responsive';

import { Context as PortalContext } from '../context/portal.context';

import MoreIcon from '@material-ui/icons/MoreHoriz';

import Thousands from '../helpers/Thousands';

import Invoice from '../pages/Invoice';


const MyTableRow = (props) => {
	const [open] = useState(false);
	const [rowMenuOpen, setRowMenuOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [selected, setSelected] = useState(false);
	const { state } = React.useContext(PortalContext);

	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1000px)' });

	const anchorRef = useRef(null);

	const prevOpen = useRef(rowMenuOpen);

	const isSelected = (row) => {
		if (props.selected.length === 0) {
			return false;
		}
		return props.selected.indexOf(row) !== -1;
	};

	const isItemSelected = isSelected(props.row);
	const labelId = `enhanced-table-checkbox-${props.index}`;

	useEffect(() => {
		if (prevOpen.current === true && rowMenuOpen === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = rowMenuOpen;
	}, [rowMenuOpen, selected]);

	const xLang = (string) => {
		return string
	}

	const handleToggle = () => {
		setRowMenuOpen((prevOpen) => !prevOpen);
	};

	const handleCloseRowMenu = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setRowMenuOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setRowMenuOpen(false);
		}
	}

	const handleMenuItemClick = (event, row) => {
		if (props.row.pdfLink !== '') {
			window.open(props.row.pdfLink);
			return;
		}
		setRowMenuOpen(false);
		setModalOpen(true);
	};

	const handleClick = (event, row) => {
		//console.log("SELECTED INVOICES", props.selected);
		const selectedIndex = props.selected.findIndex((i) => i.id === row.id);
		//console.log("SELECTED INDEX", selectedIndex);

		let newSelected = [];
		let invoices = [];

		var overDue = 0;
		if (selectedIndex === -1) {
			newSelected = newSelected.concat(props.selected, row);
			invoices = invoices.concat(row.id);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(props.selected.slice(1));
			invoices = invoices.concat(props.selected.slice(1));
		} else if (selectedIndex === props.selected.length - 1) {
			newSelected = newSelected.concat(props.selected.slice(0, -1));
			invoices = invoices.concat(props.selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				props.selected.slice(0, selectedIndex),
				props.selected.slice(selectedIndex + 1)
			);
		}
		props.setSelected(newSelected);
		props.setPaymentTotal(props.setTotal(newSelected));
	};

	if (isTabletOrMobile) {
		return (
      <TableRow
        hover
        role="checkbox"
        aria-checked={isItemSelected}
        tabIndex={-1}
        key={props.row.id}
        selected={isItemSelected}
        style={{ position: "relative" }}
      >
        {state.invoice_interface !== "amount" && (
          <TableCell padding="checkbox">
            <Checkbox
              disabled={props.row.due == 0 ? true : false}
              checked={isItemSelected}
              inputProps={{ "aria-labelledby": labelId }}
              onClick={(event) => handleClick(event, props.row)}
            />
          </TableCell>
        )}
        <TableCell component="th" id={labelId} scope="row">
          {props.row.date}
        </TableCell>
        <TableCell align="left" style={{ fontWeight: "bold" }}>
          ${Thousands(props.row.due)}
        </TableCell>

        <TableCell align="left">{props.row.description}</TableCell>
        <TableCell align="left">
          {props.row.paid === "0.00" ? "-" : props.row.paid}
        </TableCell>

        <TableCell
          align="left"
          style={{
            color: props.row.status === "Overdue" ? "red" : null,
          }}
        >
          {xLang(props.row.status)}
        </TableCell>
        <TableCell align="left" ref={anchorRef}>
          <IconButton onClick={handleToggle}>
            <MoreIcon />
          </IconButton>
          <Popper
            open={rowMenuOpen}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 10000000 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper style={{ width: 250 }} elevation={5}>
                  <ClickAwayListener onClickAway={handleCloseRowMenu}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem onClick={handleMenuItemClick}>
                        <ListItemIcon>
                          <EyeIcon />
                        </ListItemIcon>
                        <ListItemText
                          primary={
                            props.row.pdfLink !== ""
                              ? "View Invoice in new Tab"
                              : "View Invoice"
                          }
                        />
                      </MenuItem>
                      {/* <MenuItem onClick={handleMenuItemClick}>
                          <ListItemIcon>
                            <PrintIcon />
                          </ListItemIcon>
                          <ListItemText primary="Print Invoice" />
                        </MenuItem>
                        <MenuItem onClick={handleMenuItemClick}>
                          <ListItemIcon>
                            <DownloadIcon />
                          </ListItemIcon>
                          <ListItemText primary="Download PDF" />
                        </MenuItem>
                        <div
                          style={{
                            width: "100%",
                            padding: 10,
                            boxSizing: "border-box",
                          }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            style={{ width: "100%", color: "white" }}
                          >
                            Pay
                          </Button>
                        </div> */}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </TableCell>
        <Modal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            outline: "none",
          }}
        >
          <Paper
            elevation={3}
            style={{
              width: "auto",
              overflowY: "auto",
              background: "white",
              outline: "none",
              borderRadius: 5,
              position: "relative",
            }}
          >
            <IconButton
              style={{ position: "absolute", top: 15, right: 15 }}
              onClick={() => setModalOpen(false)}
            >
              <CancelIcon />
            </IconButton>
            <Invoice
              date={props.row.date}
              description={props.row.description}
              due={props.row.due}
              paid={props.row.paid}
              amount={props.row.amount}
              data={props.data}
            />
          </Paper>
        </Modal>
      </TableRow>
    );
	} else {
		return (
			<TableRow
				hover
				role="checkbox"
				aria-checked={isItemSelected}
				tabIndex={-1}
				key={props.row.id}
				selected={isItemSelected}
				style={{ position: 'relative' }}
			>
				{state.invoice_interface !== 'amount' && (
					<TableCell padding="checkbox">
						<Checkbox
							checked={isItemSelected}
							disabled={props.row.due == 0 ? true :false}
							inputProps={{ 'aria-labelledby': labelId }}
							onClick={(event) => handleClick(event, props.row)}
						/>
					</TableCell>
				)}
				<TableCell component="th" id={labelId} scope="row">
					{props.row.date}
				</TableCell>

				<TableCell align="left">{props.row.description}</TableCell>
				<TableCell align="left">
					{props.row.paid === '0.00' ? '-' : props.row.paid}
				</TableCell>

				<TableCell align="left" style={{ fontWeight: 'bold' }}>
					${Thousands(props.row.due)}
				</TableCell>
				<TableCell
					align="left"
					style={{
						color: props.row.status === 'Overdue' ? 'red' : null,
					}}
				>
					{xLang(props.row.status)}
				</TableCell>
				<TableCell align="left" ref={anchorRef}>
					<IconButton onClick={handleToggle}>
						<MoreIcon />
					</IconButton>
					<Popper
						open={rowMenuOpen}
						anchorEl={anchorRef.current}
						role={undefined}
						transition
						disablePortal
						style={{ zIndex: 10000000 }}
					>
						{({ TransitionProps, placement }) => (
							<Grow
								{...TransitionProps}
								style={{
									transformOrigin:
										placement === 'bottom'
											? 'center top'
											: 'center bottom',
								}}
							>
								<Paper style={{ width: 300 }} elevation={5}>
									<ClickAwayListener
										onClickAway={handleCloseRowMenu}
									>
										<MenuList
											autoFocusItem={open}
											id="menu-list-grow"
											onKeyDown={handleListKeyDown}
										>
											<MenuItem
												onClick={handleMenuItemClick}
											>
												<ListItemIcon>
													<EyeIcon />
												</ListItemIcon>
												<ListItemText
													primary={
														props.row.pdfLink !== ''
															? 'View Invoice in new Tab'
															: 'View Invoice'
													}
												/>
											</MenuItem>
											{/* <MenuItem onClick={handleMenuItemClick}>
                          <ListItemIcon>
                            <PrintIcon />
                          </ListItemIcon>
                          <ListItemText primary="Print Invoice" />
                        </MenuItem>
                        <MenuItem onClick={handleMenuItemClick}>
                          <ListItemIcon>
                            <DownloadIcon />
                          </ListItemIcon>
                          <ListItemText primary="Download PDF" />
                        </MenuItem>
                        <div
                          style={{
                            width: "100%",
                            padding: 10,
                            boxSizing: "border-box",
                          }}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            style={{ width: "100%", color: "white" }}
                          >
                            Pay
                          </Button>
                        </div> */}
										</MenuList>
									</ClickAwayListener>
								</Paper>
							</Grow>
						)}
					</Popper>
				</TableCell>
				<Modal
					open={modalOpen}
					onClose={() => setModalOpen(false)}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						outline: 'none',
					}}
				>
					<Paper
						elevation={3}
						style={{
							width: 'auto',
							overflowY: 'auto',
							background: 'white',
							outline: 'none',
							borderRadius: 5,
							position: 'relative',
						}}
					>
						<IconButton
							style={{ position: 'absolute', top: 15, right: 15 }}
							onClick={() => setModalOpen(false)}
						>
							<CancelIcon />
						</IconButton>
						<Invoice
							date={props.row.date}
							description={props.row.description}
							due={props.row.due}
							paid={props.row.paid}
							amount={props.row.amount}
							data={props.data}
						/>
					</Paper>
				</Modal>
			</TableRow>
		);
	}
};

export default MyTableRow;
